<template>
	<div>
		<a
			href="javascript:;"
			@click="active = !active"
			class="p-1 d-flex align-items-center"
			:style="`background-color: ${titleBackdrop}`"
		>
			<Icon v-if="active" :icon="['far', 'minus']" />
			<Icon v-else :icon="['far', 'plus']" />
			<h2 class="mb-0 ml-1">
				<strong>{{ title }}</strong>
			</h2>
		</a>
		<div :class="{ 'p-2': active }">
			<expand-transition>
				<slot v-if="active" />
			</expand-transition>
		</div>
	</div>
</template>

<script>
import ExpandTransition from '~/components/ui/Transitions/ExpandTransition'
import Icon from '~/components/ui/common/Icon'

export default {
	props: ['title', 'titleBackdrop', 'preSelected'],
	components: {
		ExpandTransition,
		Icon
	},
	data() {
		return {
			active: null
		}
	},
	created() {
		this.active = this.preSelected
	}
}
</script>
